// import React, { useCallback, useEffect, useState } from 'react';

import React from 'react';

import FSIndex from "@dndComponents/FSIndex";

// import { ModelBase, PlayerObject } from '../../../../models';
// import { Feat } from '../../models';
// import DandDAPI from '../../utilities/system_api';
// import LoadingBox from '@components/input/LoadingBox';

// const api = DandDAPI.getInstance();

export default function FeatIndex() {
  // const [fetched, setFetched] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [all_feats, setAllFeats] = useState<Feat[]>([]);

  // const load = useCallback( async () => {
  //   const objects = await api.getObjects<Feat>({ data_type: "feat" });
  //   for (const obj of objects) {
  //     await api.loadObject(obj);
  //   }
  //   setAllFeats(objects);
  //   setLoading(false);
  // }, []);

  // useEffect(() => {
  //   if (!fetched) {
  //     setFetched(true);
  //     setLoading(true);
  //     setTimeout(() => {
  //       load();
  //     }, 100);
  //   }
  // }, [fetched, load]);

  // if (!fetched || loading) {
  //   return <LoadingBox />;
  // }

  return (
    <FSIndex
      data_type="feat"
      // save_all
      quick_fields={["feat_tier","ability_scores","tags"]}
      // extra_filter={(obj: ModelBase | PlayerObject) => {
      //   if (obj instanceof Feat) {
      //     return obj.ability_scores.length === 0; 
      //     // return obj.feature_bases.some(o => o.features.some(o2 => !o2.floating_feature));

      //     // const variants = obj.variant_group.filter(o => o.source_book_ids.includes("6675b302a4476741138fa22b"));
      //     // if (variants.length === 0) {
      //     //   if (obj.source_book_ids.length === 1 && obj.source_books[0].third_party) {

      //     //   } else {
      //     //     return true;
      //     //   }
      //     // }
      //   }
      //   return false;
      // }}
    />
  );
}
